/*
  SolarGen · Halterungsbilder in der Produktgalerie
  ----------------------------------------------------------------
  snippets/product-gallery.liquid rendert auf Konfigurator-Seiten die Bilder
  der Halterungs-Produkte versteckt ans Ende der Galerie (data-sg-halt-handle).
  Dieses Script blendet die Bilder der im Konfigurator gewählten Halterung ein
  und springt beim Auswählen auf das erste davon. „Ohne Halterung" blendet
  sie wieder aus.

  Nutzt den theme-eigenen Filter-Mechanismus (carousel:filter / control:filter),
  damit Carousel, Thumbnails, Punkte und Zoom konsistent bleiben.
*/
(function () {
  if (window.__sgHaltGallery) return;
  window.__sgHaltGallery = true;

  /* a4p-Familie (Anker, EcoFlow, Hoymiles, Jupiter, Basic) + sg-bkw-configurator */
  var RADIO_SELECTOR = 'input[name^="sg-a4p-halt-"], input[data-sg-halt]';

  /* Fallback, wenn das Radio kein data-handle trägt (a4p-Familie). */
  var KEY_TO_HANDLE = {
    flachdach: 'flachdachhalterung-fassadenhalterung',
    fassade: 'flachdachhalterung-fassadenhalterung',
    balkon: 'balkonhalterung',
    ziegeldach: 'ziegeldachhalterung',
    garten: 'valkbox3-flachdachhalterung-fur-solarmodule'
  };

  /* ---------- Vorladen ----------
     Die versteckten Bilder sind loading="lazy" und würden erst beim Einblenden
     geladen. Wir holen sie vorher: beim Hover/Touch auf eine Halterung sofort,
     sonst alle, sobald der Browser nach dem Seitenaufbau Luft hat. */
  var warmed = {};
  function warm(handle) {
    if (!handle || warmed[handle]) return;
    warmed[handle] = true;
    document.querySelectorAll('[data-sg-halt-handle="' + handle + '"] img[loading="lazy"]').forEach(function (img) {
      img.removeAttribute('loading');
    });
  }
  function handleForInput(input) {
    if (!input || input.value === 'ohne' || input.value === 'keine') return null;
    return input.getAttribute('data-handle') || KEY_TO_HANDLE[input.value] || null;
  }
  function warmFromEvent(event) {
    var el = event.target && event.target.closest ? event.target.closest('label, .sg-a4p__halt, .sg-bkw__halt') : null;
    if (!el) return;
    var input = el.matches(RADIO_SELECTOR) ? el : el.querySelector(RADIO_SELECTOR);
    if (!input && el.htmlFor) input = document.getElementById(el.htmlFor);
    if (input && input.matches(RADIO_SELECTOR)) warm(handleForInput(input));
  }
  document.addEventListener('pointerover', warmFromEvent, { passive: true });
  document.addEventListener('touchstart', warmFromEvent, { passive: true });
  document.addEventListener('focusin', warmFromEvent);

  function warmAllWhenIdle() {
    var conn = navigator.connection || {};
    if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
    var run = function () { Object.keys(KEY_TO_HANDLE).forEach(function (k) { warm(KEY_TO_HANDLE[k]); }); };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 2500);
  }

  function selectedHandle() {
    var input = document.querySelector(RADIO_SELECTOR.split(', ').map(function (s) { return s + ':checked'; }).join(', '));
    return input && input.value ? handleForInput(input) : null;
  }

  function galleries() {
    return Array.prototype.filter.call(document.querySelectorAll('product-gallery'), function (g) {
      return g.querySelector('[data-sg-halt-handle]');
    });
  }

  function sync(jump) {
    var handle = selectedHandle();
    warm(handle);

    galleries().forEach(function (gallery) {
      var carousel = gallery.querySelector('media-carousel');
      if (!carousel) return;

      var baseFiltered = [];
      try {
        baseFiltered = JSON.parse(gallery.getAttribute('filtered-indexes') || '[]').map(function (i) { return parseInt(i, 10) - 1; });
      } catch (e) {}

      var slides = Array.prototype.slice.call(carousel.children);
      var filtered = [];
      var firstHaltIndex = -1;
      slides.forEach(function (slide, index) {
        var h = slide.getAttribute('data-sg-halt-handle');
        if (h) {
          if (h !== handle) filtered.push(index);
          else if (firstHaltIndex === -1) firstHaltIndex = index;
        } else if (baseFiltered.indexOf(index) !== -1) {
          filtered.push(index);
        }
      });

      var wasOnHidden = false;
      var current = typeof carousel.selectedIndex === 'number' ? carousel.selectedIndex : 0;
      if (filtered.indexOf(current) !== -1) wasOnHidden = true;

      var wasHidden = slides.map(function (slide) { return slide.hidden; });
      carousel.dispatchEvent(new CustomEvent('carousel:filter', { detail: { filteredIndexes: filtered } }));
      if (jump) {
        gallery.querySelectorAll('[data-sg-halt-handle="' + handle + '"]').forEach(function (el) {
          if (el.parentNode === carousel && !wasHidden[slides.indexOf(el)]) return;
          el.classList.remove('sg-halt-in');
          void el.offsetWidth;
          el.classList.add('sg-halt-in');
        });
      }
      gallery.querySelectorAll('page-dots').forEach(function (dots) {
        dots.dispatchEvent(new CustomEvent('control:filter', { detail: { filteredIndexes: filtered } }));
      });

      if (typeof carousel.select !== 'function') return;
      if (jump && firstHaltIndex !== -1) {
        /* Ohne Animation: Die Halterungsbilder liegen am Ende der Galerie,
           ein Smooth-Scroll von Bild 1 aus rauscht sichtbar über alle Bilder. */
        carousel.select(firstHaltIndex, { animate: false });
      } else if (wasOnHidden) {
        var firstVisible = 0;
        while (filtered.indexOf(firstVisible) !== -1 && firstVisible < slides.length - 1) firstVisible++;
        carousel.select(firstVisible, { animate: false });
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches(RADIO_SELECTOR)) sync(true);
  });

  /* Soft-Swap (Modul-Leistung) ersetzt die ganze Produkt-Section inkl. Galerie. */
  document.addEventListener('sg:soft-swap', function () {
    warmed = {};
    setTimeout(function () { sync(false); warmAllWhenIdle(); }, 50);
  });
  window.addEventListener('pageshow', function () { sync(false); });
  window.addEventListener('load', warmAllWhenIdle);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(false); });
  } else {
    sync(false);
  }
})();
